import React, { FunctionComponent } from 'react'
import style from './style.scss'

const TopBar: FunctionComponent = ({children}) => {
  return <div className={style.topBar}>{children}</div>
}

export default TopBar
